export const LOGIN_EMAIL = 'LOGIN_EMAIL'
